import { useEffect } from 'react'
import HowBecomeAMember from "components/Homepage/HowBecomeAMember";
import HowToConfirmMembership from "components/Homepage/HowToConfirmMembership";
import MembershipAdvantages from "components/Homepage/MembershipAdvantages";
import Support from "components/Homepage/Support";
import WhoBecomeAMember from "components/Homepage/WhoBecomeAMember";

function Application() {

    useEffect(() => {
        setTimeout(() => {
            var url = window.location
            var loc = new URL(url)
            var path = loc.pathname
            var userAgent = navigator.userAgent || navigator.vendor || window.opera
            if (/android/i.test(userAgent)) {
                window.location.replace("sachapartner:/" + path)
                setTimeout(function () {
                    window.location.replace("https://play.google.com/store/apps/details?id=com.sachapartner.android")
                }, 200)
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                window.location.replace("sachapartner:/" + path)
                setTimeout(function () {
                    window.location.replace("https://apps.apple.com/us/app/sachapartner/id6444608558")
                }, 200)
            }
        }, 1000)
    }, [])

    return (
        <div className='flex flex-col space-y-6 bg-background '>
            <div className="flex justify-center w-full pt-10">
                <img src="/partner_logo.png" alt="partner_logo" width={382} height={176} />
            </div>
            <MembershipAdvantages />
            <WhoBecomeAMember />
            <HowBecomeAMember />
            <HowToConfirmMembership />
            <Support />
        </div>
    )
}

export default Application